"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const stats = [{
  value: "6.45%",
  label: "30-Year Fixed\nDaily Change: -0.02%"
}, {
  value: "5.82%",
  label: "15-Year Fixed\nDaily Change: +0.01%"
}, {
  value: "6.15%",
  label: "FHA Loans\nDaily Change: -0.05%"
}, {
  value: "5.95%",
  label: "VA Home Loans\nDaily Change: 0.00%"
}];
export default function MarketPulse() {
  return <section data-section-id="262309" id="market-pulse" className="dark bg-background text-foreground py-16 lg:py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='200' height='200' viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 80 C 40 10, 65 10, 95 80 S 150 150, 180 80' stroke='%23ffffff' fill='transparent'/%3E%3C/svg%3E")`,
      backgroundSize: '400px 400px'
    }} />
      
      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col lg:flex-row items-center flex-1 w-full group transition-all duration-500">
              <div className="flex-1 flex flex-col items-center text-center py-8 lg:py-0 px-4 w-full transition-all duration-300 group-hover:drop-shadow-[0_0_15px_rgba(158,255,210,0.6)]">
                <h3 className="text-5xl lg:text-7xl font-bold font-serif mb-4 tracking-tighter text-primary-foreground">
                  {stat.value}
                </h3>
                <p className="text-xs lg:text-sm font-mono whitespace-pre-line leading-snug uppercase tracking-widest text-primary-foreground">
                  {stat.label}
                </p>
              </div>
              
              {i < stats.length - 1 && <div className="flex items-center justify-center shrink-0">
                  {}
                  <Separator orientation="vertical" className="hidden lg:block h-28 bg-primary-foreground/40 w-[2px]" />
                  {}
                  <Separator orientation="horizontal" className="lg:hidden w-24 bg-primary-foreground/40 h-[2px]" />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}